import React, { useState, useCallback, useEffect } from 'react';
import { cssRule } from 'typestyle';
import { Routes, Route } from 'react-router-dom';
import AppConstants from './app.constants';
import { useRoutes } from './routes';
import Page from './components/page/page.component';
import { IsMobileProvider } from './context/is-mobile';
import StyleConstants from './styles.constants';
import Authenticated from './components/authenticated/authenticated.component';
import DefaultToastContainer from './components/notify/toast-container.component';

const App = (): React.JSX.Element => {
  cssRule('body', {
    fontFamily: StyleConstants.PRIMARY_FONT_FAMILY,
    fontWeight: StyleConstants.PRIMARY_FONT_WEIGHT,
    fontSize: StyleConstants.PRIMARY_FONT_SIZE,
    color: StyleConstants.WHITE_COLOR,
    background: 'radial-gradient(65.48% 68.87% at 59.9% 24.56%, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%), #EDEFF4',
    overflow: 'hidden',
  });

  const routes = useRoutes();
  document.title = AppConstants.APP_TITLE;

  const [isMobile, setIsMobile] = useState<boolean>(window.innerWidth <= AppConstants.MINIMUM_DESKTOP_WIDTH);

  const onResize = useCallback(() => {
    setIsMobile(window.innerWidth <= AppConstants.MINIMUM_DESKTOP_WIDTH);
  }, []);

  useEffect(() => {
    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, [onResize]);

  return (
    <IsMobileProvider value={isMobile}>
      <Authenticated>
        <Page>
          <Routes>
            {routes.map((route) => (
              <Route key={route.path} path={route.path} element={route.element} />
            ))}
          </Routes>
        </Page>
      </Authenticated>
      <div>
        <DefaultToastContainer />
      </div>
    </IsMobileProvider>
  );
};

export default App;
